import { config } from 'js-xdr';

export function toLineItemProperty(bundle: { variantId: string; version: number; items: any[] }) {
  const opts = {
    variantId: xdr.Uint64.fromString(bundle.variantId.toString()),
    version: bundle.version || Math.floor(Date.now() / 1000),
    items: bundle.items.map(item => {
      return new xdr.BundleItem({
        collectionId: xdr.Uint64.fromString(item.collectionId.toString()),
        productId: xdr.Uint64.fromString(item.productId.toString()),
        variantId: xdr.Uint64.fromString(item.variantId.toString()),
        sku: item.sku || '',
        quantity: item.quantity,
        ext: new xdr.BundleItemExt(0),
      });
    }),
    ext: new xdr.BundleExt(0),
  };

  const xdrBundle = new xdr.Bundle(opts);
  return xdr.BundleEnvelope.envelopeTypeBundle(xdrBundle).toXDR('base64');
}

const xdr = config(
  (xdr: {
    enum: (arg0: string, arg1: { envelopeTypeBundle: number }) => void;
    typedef: (arg0: string, arg1: any) => void;
    uint: () => any;
    uhyper: () => any;
    union: (
      arg0: string,
      arg1: {
        switchOn: any;
        switchName: string;
        switches: any[][] | string[][];
        // eslint-disable-next-line @typescript-eslint/ban-types
        arms: {} | {} | { v1: any };
      }
    ) => void;
    int: () => any;
    void: () => any;
    struct: (arg0: string, arg1: any[][]) => void;
    lookup: (arg0: string) => any;
    string: () => any;
    varArray: (arg0: any, arg1: number) => any;
  }) => {
    xdr.enum('EnvelopeType', {
      envelopeTypeBundle: 0,
    });
    xdr.typedef('Uint32', xdr.uint());
    xdr.typedef('Uint64', xdr.uhyper());
    xdr.union('BundleItemExt', {
      switchOn: xdr.int(),
      switchName: 'v',
      switches: [[0, xdr.void()]],
      arms: {},
    });
    xdr.struct('BundleItem', [
      ['collectionId', xdr.lookup('Uint64')],
      ['productId', xdr.lookup('Uint64')],
      ['variantId', xdr.lookup('Uint64')],
      ['sku', xdr.string()],
      ['quantity', xdr.lookup('Uint32')],
      ['ext', xdr.lookup('BundleItemExt')],
    ]);
    xdr.union('BundleExt', {
      switchOn: xdr.int(),
      switchName: 'v',
      switches: [[0, xdr.void()]],
      arms: {},
    });
    xdr.struct('Bundle', [
      ['variantId', xdr.lookup('Uint64')],
      ['items', xdr.varArray(xdr.lookup('BundleItem'), 500)],
      ['version', xdr.lookup('Uint32')],
      ['ext', xdr.lookup('BundleExt')],
    ]);
    xdr.union('BundleEnvelope', {
      switchOn: xdr.lookup('EnvelopeType'),
      switchName: 'type',
      switches: [['envelopeTypeBundle', 'v1']],
      arms: {
        v1: xdr.lookup('Bundle'),
      },
    });
  }
);
